import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icons Small/Arrow left NAV",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M5.95063 10.3397L14.6361 1.63875C14.6634 1.61211 14.6851 1.58027 14.7 1.5451C14.7148 1.50993 14.7225 1.47214 14.7225 1.43397C14.7225 1.3958 14.7148 1.35802 14.7 1.32285C14.6851 1.28768 14.6634 1.25584 14.6361 1.2292C14.6094 1.20186 14.5776 1.18014 14.5424 1.1653C14.5073 1.15047 14.4695 1.14282 14.4313 1.14282C14.3931 1.14282 14.3554 1.15047 14.3202 1.1653C14.285 1.18014 14.2532 1.20186 14.2265 1.2292L5.36336 10.131C5.33602 10.1577 5.31429 10.1895 5.29946 10.2247C5.28462 10.2598 5.27698 10.2976 5.27698 10.3358C5.27698 10.374 5.28462 10.4117 5.29946 10.4469C5.31429 10.4821 5.33602 10.5139 5.36336 10.5406L14.242 19.4424C14.2686 19.4707 14.301 19.493 14.337 19.5076C14.373 19.5223 14.4118 19.529 14.4506 19.5274C14.4883 19.5284 14.5257 19.5214 14.5603 19.5067C14.595 19.4921 14.6261 19.4701 14.6515 19.4424C14.6789 19.4157 14.7006 19.3839 14.7154 19.3487C14.7303 19.3136 14.7379 19.2758 14.7379 19.2376C14.7379 19.1994 14.7303 19.1617 14.7154 19.1265C14.7006 19.0913 14.6789 19.0595 14.6515 19.0328L5.95063 10.3397Z",
			fill: "#0567D5",
			stroke: "#0567D5"
		})
	})
});
export default SvgIconArrowLeft;
